import React from 'react';
import classNames from 'classnames';
import ParsedContent from '../ParsedContent';

import './CodeSparkThemedTypography.css';

const validVariantsToElementMapping = new Map([
  ['h1', 'h1'],
  ['h2', 'h2'],
  ['h3', 'h3'],
  ['h4', 'h4'],
  ['h5', 'h5'],
  ['h6', 'h6'],
  ['subtitle1', 'p'],
  ['subtitle2', 'p'],
  ['subtitle3', 'p'],
  ['body1', 'p'],
  ['body2', 'p'],
  ['body3', 'p'],
  ['finePrint', 'p'],
  ['legal', 'p'],
  ['button1', 'span'],
  ['button2', 'span'],
  ['button3', 'span'],
  ['link1', 'span'],
  ['link2', 'span'],
  ['link3', 'span'],
  ['srOnly', 'span'],
]);

const supportedTextAligns = new Set(['left', 'right', 'center', 'justify']);

// Porting the typography over from design spec that in also on fooaccounts
function CodeSparkThemedTypography({
  variant = 'body1',
  className,
  children,
  Element,
  align,
  parseText,
}) {
  const variantToUse = validVariantsToElementMapping.has(variant) ? variant : 'body1';

  const classes = `themed-typography themed-typography-${variantToUse}`;
  const ElementToUse = Element || validVariantsToElementMapping.get(variantToUse);

  return (
    <ElementToUse
      className={classNames(classes, className, {
        [`themed-typography-${align}`]: supportedTextAligns.has(align),
      })}
    >
      {parseText ? <ParsedContent>{children}</ParsedContent> : children}
    </ElementToUse>
  );
}

export default CodeSparkThemedTypography;



// WEBPACK FOOTER //
// ./src/components/elements/CodeSparkThemedTypography/index.js